import {useContext, useState} from "react";
import loadingIcon from "../../assets/images/loading.svg";
import './feedback.css';
import {dataContext} from "../../context/context";

function Feedback() {

    const { isLocal, isBY  } = useContext(dataContext);
    let feedbackUrl = "/feedback.php";
    if (isLocal) feedbackUrl = "https://fnxstudio.ru" + feedbackUrl;

    const [formData, setFormData] = useState({
        name: "",
        phone: "",
        description: "",
        nobot: 0
    });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // success | error | null

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
            "nobot": 1
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();
        setLoading(true);
        setStatus(null);

        try {



                const response = await fetch(feedbackUrl, {
                method: "POST",
                headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                },
                body: new URLSearchParams(formData)

            });

            const data = await response.json();

            if (data.success === true) {
                setStatus("success");
            } else {
                setStatus("error");
            }
        } catch (error) {
            setStatus("error");
        } finally {
            setLoading(false);
        }
    };

    if (status === "success") {
        return (
         <>
            <h3>Успешно отправлено</h3>
            ожидайте обратной связи
         </>
        )
    }

    else if (status === "error") {
        return <h3>При отправке произошла ошибка</h3>;
    }

    else if (loading) {
        return <><img src={loadingIcon} /></>;
    }

    else return (

        <div className="feedback">
            <form onSubmit={handleSubmit}>
                <input name="name" type="text" placeholder="Ваше имя" value={formData.name} onChange={handleChange}  required />
                <input name="phone" type="phone" placeholder="Телефон" value={formData.phone} onChange={handleChange}  required />
                <textarea name="description" placeholder="Ваш город, опишите вкратце что вы хотите заказать" onChange={handleChange}  required >{formData.city}</textarea>
                <div><input name="agree" type="checkbox" value="1" required /><span> согласен с обработкой персональных данных</span></div>
                <button>Отправить</button>
            </form>
        </div>

    )

}

export default Feedback;


